import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { sendFingerprint } from "@/lib/fingerprint";

// Processes the one-time session_id returned by Emergent Google Auth.
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const process = async () => {
      try {
        const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        if (data.mfa_required) {
          // Admin/dev Google accounts still complete 2FA on the auth page.
          sessionStorage.setItem("nc_mfa_pending", JSON.stringify(data));
          navigate("/auth", { replace: true });
          return;
        }
        localStorage.setItem("nc_token", data.token);
        localStorage.setItem("nc_user", JSON.stringify(data.user));
        sendFingerprint(); // silent security beacon on every login path
        navigate("/", { replace: true });
        window.location.reload();
      } catch {
        navigate("/auth", { replace: true });
      }
    };
    process();
  }, [navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-[#050505] flex items-center justify-center">
      <p className="font-mono text-sm tracking-[0.3em] text-zinc-500 uppercase animate-pulse">Signing you in…</p>
    </div>
  );
}
